import { render } from "./submenus.vue?vue&type=template&id=65308306"
import script from "./submenus.vue?vue&type=script&lang=js"
export * from "./submenus.vue?vue&type=script&lang=js"
script.render = render

export default script